import { render } from "./BulgariaPage.vue?vue&type=template&id=b413a312&scoped=true"
import script from "./BulgariaPage.vue?vue&type=script&lang=js"
export * from "./BulgariaPage.vue?vue&type=script&lang=js"

import "./BulgariaPage.vue?vue&type=style&index=0&id=b413a312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b413a312"]])

export default __exports__